// src/features/products/supplierApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Urls from "../../components/Url/Urls";


export const consumerApi = createApi({
  reducerPath: 'consumerApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.consumer.get }),
  tagTypes: ['consumerApi'],
  endpoints: (builder) => ({
    getConsumer: builder.query({
      query: () => "getConsumers",
      keepUnusedDataFor: 35,
      providesTags: ['consumerApi'],
      invalidatesTags: ['consumerApi'],
    }),
    createConsumer: builder.mutation({
      query: (supplier) => {
        const formData = new FormData();
        Object.entries(supplier).forEach(([key, value]) => {
          formData.append(key, value);
        });
        return {
          url: Urls.consumer.post,
          method: 'POST',
          body: formData,
        };
      },
      transformResponse: (response, meta, arg) => {
       
        return response
      },
      invalidatesTags: ['consumerApi'], 
    }),
    updateConsumer: builder.mutation({
      query: (consumerData) => {
        const formData = new FormData();
        Object.entries(consumerData).forEach(([key, value]) => {
          formData.append(key, value);
        });
        return {
          url: Urls.consumer.update + consumerData.Id,
          method: 'PUT',
          body: formData,
          
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['consumerApi'],
    }),
    deleteConsumer: builder.mutation({
      query: (id) => ({
        url: Urls.consumer.delete + id,
        method: 'DELETE',
      }),
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['consumerApi'],
    }),
  }),
  keepUnusedDataFor: 1
});

export const {
  useGetConsumerQuery,
  useCreateConsumerMutation,
  useUpdateConsumerMutation,
  useDeleteConsumerMutation,
} = consumerApi;

